<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Cập nhật yêu cầu đặt vé
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Ghi chú" prop="note">
              <el-input
                type="textarea"
                v-model="form.note"
                placeholder="Ghi chú"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="500"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <hc-maybay-upload
              :hcCaseFlightFileType="HC_CASE_FLIGHT_FILE.TYPE.VE_MAY_BAY"
              :hcCaseFlightId="id"
              :validateUploadFileOptions="veMayBayValidateFileOptions"
              ref="hcMaybayUpload"
            ></hc-maybay-upload>
          </el-col>

          <el-col :span="24" v-if="!!hcCaseFight">
            <hc-maybay-user-route
              ref="hcMaybayUserRoutes"
              :hcCaseMasterId="hcCaseFight.caseMasterId"
            ></hc-maybay-user-route>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          Cập nhật
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
          >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import uploadFileMixin from "../../doc-in/uploadFileMixin";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import vbAttachmentTokenMixin from "../../../mixins/vbAttachmentTokenMixin";
import HcMaybayUsers from "./hc-maybay-users";
import HcMaybayRoutes from "./hc-maybay-routes";
import CustomDialog from "../../common/custom-dialog";
import HcMaybayUpload from "./hc-maybay-upload";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import hcCaseFlightService from "../../../services/maybay/hcCaseFlightService";
import constants from "../../../constants";
import HcMaybayUserRoute from "./hc-maybay-user-route";
import h from "../../../services/h";
import hanhChinhUtils from "../../../services/hanhChinhUtils";

export default {
  name: "hc-maybay-update-dialog",
  mixins: [handleRequestErrorMixin, uploadFileMixin, vbAttachmentTokenMixin],
  props: ["isOpen", "id"],
  components: {
    HcMaybayUserRoute,
    HcMaybayRoutes,
    HcMaybayUpload,
    CustomDialog,
    HcMaybayUsers
  },

  data() {
    return {
      rules: {
        note: null,
        flightRouteList: null,
        flightFileList: null
      },
      form: {
        note: null,
        flightRouteList: [],
        flightFileList: []
      },
      hcCaseFight: null,
      HC_CASE_FLIGHT_FILE: constants.HC_CASE_FLIGHT_FILE,
      veMayBayValidateFileOptions: null
    };
  },

  computed: {},

  watch: {},

  async created() {
    this.initValidationRules();
    this.initMayBayFileValidateFileOptions();
    await this.loadHcCaseFight();
    this.initFormForEdit();
  },

  methods: {
    initMayBayFileValidateFileOptions() {
      this.veMayBayValidateFileOptions = hanhChinhUtils.initMayBayFileValidateFileOptions(
        constants.HC_CASE_FLIGHT_FILE.TYPE.VE_MAY_BAY
      );
    },

    initFormForEdit() {
      this.form.note = this.hcCaseFight.note;
    },

    loadHcCaseFight() {
      return hcCaseFlightService
        .findById(this.id)
        .then(response => (this.hcCaseFight = response.data));
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };
      this.rules.note = [defaultRequiredConstrains];
    },

    validateUploadFiles() {
      return new Promise(resolve => {
        let files = this.$refs.hcMaybayUpload.getData();
        if (!files || !files.length) {
          this.$message.error(
            errorMessageFilter({ errorCode: "hcMayBay.ticketFiles.required" })
          );
        } else {
          resolve();
        }
      });
    },

    validateUserRoutes() {
      return new Promise(resolve => {
        let userRoutes = this.$refs.hcMaybayUserRoutes.getData();
        let invalid = h.exists(
          userRoutes,
          userRoute => !userRoute.ticketNumber || !userRoute.flightTimeRealistic
        );
        if (invalid) {
          this.$message.error(
            errorMessageFilter({ errorCode: "hcMayBay.userRoutes.required" })
          );
        } else {
          resolve();
        }
      });
    },

    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (!valid) {
            this.$message.error("Có lỗi nhập liệu. Vui lòng kiểm tra lại");
          } else {
            resolve();
          }
        });
      });
    },

    convertToSubmitForm() {
      return {
        action: constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.CAP_NHAT,
        caseMasterId: this.hcCaseFight.caseMasterId,
        note: this.form.note,
        flightRouteList: this.$refs.hcMaybayUserRoutes.getData(),
        flightFileList: this.$refs.hcMaybayUpload.getData()
      };
    },

    submit() {
      this.validateForm()
        .then(() => this.validateUploadFiles())
        .then(() => this.validateUserRoutes())
        .then(() => {
          let submitForm = this.convertToSubmitForm();
          // console.log(JSON.stringify(submitForm));
          return hcCaseFlightService
            .update(submitForm)
            .then(response => response.data);
        })
        .then(hcCaseFlight => {
          this.$message.success(
            errorMessageFilter({
              errorCode: "hcFlight.updateSuccess"
            })
          );
          this.$emit("updateSuccess", { result: hcCaseFlight });
        })
        .catch(error => {
          this.commonHandleRequestError(error);
          throw error;
        });
    }
  }
};
</script>

<style type="text/css" scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/vemaybay/hc-maybay-update-dialog.vue